export const THIRD_DEGREE = {
  id: 'third_degree',
  label: 'Sì, 3° grado',
};

export const FOURTH_DEGREE = {
  id: 'fourth_degree',
  label: 'Sì, 4° grado',
};

export const NONE_OR_MINOR = {
  id: 'none_or_minor',
  label: 'No, assenti, 1° grado, 2° grado',
};
